'use strict';
var parent = require('../../es/set');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/stable/set/index.js
// module id = 1556
// module chunks = 0